import useConnectionState from "#/hooks/useConnectionState";

export default function ConnectionState() {
  const { isOnline } = useConnectionState();

  if (isOnline) {
    // do not show anything when online
    return null;
  }

  return <span className="icon icon-wifi-off is-medium"></span>;
}
